import { Link } from "react-router-dom";
import "./Menu.css";
import React, { useState, useEffect } from "react";
import { useDBContext } from "../Context/DBcontext";

export default function MenuCont({ render }) {
  const [open, setOpen] = useState(true);


  const {
    articles,
    getArticles
  } = useDBContext();

  useEffect(() => {
    if(articles.length === 0){
        getArticles()
    }
  }, [])




  const openF = () => {
    setOpen(!open);
  };

  useEffect(() => {
    setOpen(false);
  }, [render]);

  function getMostRecentArticles(articles, category, limit) {
    return articles
      .filter(article => article.category.toUpperCase() === category.toUpperCase()) // Filtra por la posición
      .sort((a, b) => new Date(b.date) - new Date(a.date)) // Ordena por fecha de forma descendente
      .slice(0, limit); // Selecciona los primeros artículos hasta el límite especificado
  }


  let tapaArticles = getMostRecentArticles(articles, "Nota de tapa", 4);
  let historiaArticles = getMostRecentArticles(articles, "Historia", 4);
  let textosMillonariosArticles = getMostRecentArticles(articles, "Textos millonarios", 4);
  let historiasMonumentalesArticles = getMostRecentArticles(articles, "Historias monumentales", 4);

  const [subscription, setSubscription] = useState(false)

  const openSuscription = () => {
    setSubscription(!subscription)
  }

  return (
    <div className={`menu-cont ${open ? "menu-cont-open" : ""}`}>
      <button
        onClick={openF}
        className={`menu-burger ${open ? "menu-burger-open" : ""} `}
      >
        <p className={`burger1 ${open ? "burger1open" : ""}`}></p>
        <p className={`burger2 ${open ? "burger2open" : ""}`}></p>
        <p className={`burger3 ${open ? "burger3open" : ""}`}></p>
      </button>

      {open ? (
        <>
          <div className="menu-row">
          <div className="menu-column" onClick={openF}>
               <img className='menu-sidebar-logo' src="https://firebasestorage.googleapis.com/v0/b/revista1986-c6922.appspot.com/o/logo1986_square.png?alt=media&token=dde69511-bd57-4924-9174-44859fa5a516" alt="" />
       
            </div>

     
            <div className="menu-column" onClick={openF}>

              <Link  onClick={() => {
            window.scrollTo(0, 0)
          }}to="/articulos/notas-de-tapa" className="menu-item-title">
                Notas de tapa{" "}
              </Link>
              {tapaArticles.map((e, index) =>
                        <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to={`/article/${e.id}`} key={index} className="menu-item-subtitle2"> {e.title} </Link>

              )}
       
            </div>
            <div className="menu-column" onClick={openF}>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to="/articulos/historia" className="menu-item-title">
                Historia{" "}
              </Link>
              {historiaArticles.map((e, index) =>
                        <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to={`/article/${e.id}`} key={index} className="menu-item-subtitle2"> {e.title} </Link>

              )}
       
            </div>

            <div className="menu-column" onClick={openF}>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to="/articulos/textos-millonarios" className="menu-item-title">
               Textos millonarios
              </Link>
              {textosMillonariosArticles.map((e, index) =>
                        <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to={`/article/${e.id}`} key={index} className="menu-item-subtitle2"> {e.title} </Link>

              )}
       
            </div>

            <div className="menu-column" onClick={openF}>
              <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to="/articulos/historias-monumentales" className="menu-item-title">
                Historias monumentales{" "}
              </Link>
              {historiasMonumentalesArticles.map((e, index) =>
                        <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to={`/article/${e.id}`} key={index} className="menu-item-subtitle2"> {e.title} </Link>

              )}
       
            </div>

            <div className="menu-column2" onClick={openF}>
              <a target="_blank" href="https://tienda1986.com.ar/" className="menu-item-title red">
                Tienda
              </a>

              <Link onClick={() => {
            window.scrollTo(0, 0)
          }}  to={`/article/gZG4OYADsvRAJ3mv1Ste`} className="menu-item-title red">
                Suscribite
              </Link>

            </div>

          </div>
        </>
      ) : (
        <></>
      )}

   
    </div>
  );
}
